// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__zNDL0","container":"styles_container__6BOP8","title":"styles_title__3-dpZ","wrapper":"styles_wrapper__2Ej-9","answer":"styles_answer__1kepX"};